import AlertDialog from "../alert-dialog/AlertDialog.component";
import { useState } from "react";

const ButtonWithComfirmation = ({
  onClick,
  className,
  children,
  disabled,
  title,
  contentText, 
  handleYesText,
  ...rest
}) => {
  const [showAlert, setShowAlert] = useState(false);

  const openDialog = () => setShowAlert(true);
  const hideDialog = () => setShowAlert(false);
  return (
    <>
      <button
        type="button"
        title={title}
        onClick={openDialog}
        className={className}
        disabled={disabled}
        {...rest}
      >
        {children}
      </button>
      {showAlert && (
        <AlertDialog
          handleYes={() => {
            onClick();
            hideDialog();
          }}
          handleNo={hideDialog}
          show={showAlert}
          contentText={contentText}
          handleYesText={handleYesText}
        ></AlertDialog>
      )}
    </>
  );
};

export default ButtonWithComfirmation;
